import './styles/index.css'
import './styles/profile.css'

import React, { useEffect, useState } from 'react'
import { Button, Divider, Modal, Spin, Tabs, notification } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import {
  update_visibility,
  update_active_menu_tab
} from '../../slices/restaurantSlice'
import MenuTipsContent from '../../components/Restaurant/menuTips'
import FooterDisplay from '../../components/Restaurant/Footer'
import RestaurantMenuContent from '../../components/RestaurantMenuContent'
import RawFoodMenuContent from '../../components/RawFoodMenuContent'
import StoreMenuContent from '../../components/StoreMenuContent'
import useCategories from '../../hooks/useCategories'

const RestaurantMenu = () => {
  const { TabPane } = Tabs
  const dispatch = useDispatch()
  const user = useSelector(state => state.userProfile.dataFetched)
  const { categories } = useCategories(user?.business?.id)

  const [page, setPage] = useState(1)
  const [per_page, setPerPage] = useState(10)
  const [updateCount, setUpdateCount] = useState(1)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [restaurantId, setRestaurantId] = useState(null)
  const [activeTab, setActiveTab] = useState('')

  useEffect(() => {
    if (user?.isRestaurantOwner) {
      setActiveTab('restaurant')
    } else if (user?.isRawFoodOwner) {
      setActiveTab('raw_food')
    } else if (user?.isStoreOwner) {
      setActiveTab('store')
    } else {
      setActiveTab('restaurant')
    }
  }, [user])

  const handleTipCancel = () => {
    setIsModalVisible(false)
  }

  const handlePageChange = (page, pageSize) => {
    setPage(page)
    setPerPage(pageSize)
  }

  const onShowSizeChange = (current, size) => {
    setPerPage(size)
  }

  const drawerVisibility = () => {
    dispatch(update_visibility(true))
    dispatch(update_active_menu_tab(activeTab))
  }

  return (
    <div className='userprofile'>
      <div className='profile-content pb-40'>
        <div className='gray_bg_profile'>
          <div className='profile_to_left'>
            <div className='profile_nav'></div>
          </div>
          <div className='profile_to_right'>
            <div className='contain'>
              <div className='main_container'>
                <div className='main_container_title_div mb-5'>
                  <div className='flex items-center flex-wrap p-6 gap-y-3 justify-between'>
                    <h5 className='mt-0'>My Sales Items</h5>
                    <div className='flex gap-2 flex-wrap items-center'>
                      {/* <Button
                          type="primary"
                          onClick={showTipModal}
                          className="add-menu-button"
                          shape="round"
                        >
                          Menu tips
                        </Button> */}

                      <Button
                        type='primary'
                        onClick={drawerVisibility}
                        className='add-menu-button'
                        shape='round'
                      >
                        Add Item
                      </Button>
                    </div>
                  </div>
                  <Divider style={{ margin: '0px 0 5px' }} />
                </div>

                <Tabs
                  defaultActiveKey='restaurant'
                  type='card'
                  onChange={val => {
                    dispatch(update_active_menu_tab(val))
                    setActiveTab(val)
                  }}
                >
                  {user?.isRestaurantOwner && (
                    <TabPane tab='Restaurant' key='restaurant'>
                      <RestaurantMenuContent
                        page={page}
                        per_page={per_page}
                        user={user}
                        handlePageChange={handlePageChange}
                        onShowSizeChange={onShowSizeChange}
                        updateCount={updateCount}
                        categories={categories?.filter(
                          x => x.featureType === 'restaurant'
                        )}
                        onRestaurantIdChange={setRestaurantId}
                      />
                    </TabPane>
                  )}

                  {user?.isRawFoodOwner && (
                    <TabPane tab='Wholesale' key='raw_food'>
                      <RawFoodMenuContent
                        page={page}
                        per_page={per_page}
                        user={user}
                        handlePageChange={handlePageChange}
                        onShowSizeChange={onShowSizeChange}
                        categories={categories?.filter(
                          x => x.featureType === 'raw_food'
                        )}
                        updateCount={updateCount}
                      />
                    </TabPane>
                  )}

                  {user?.isStoreOwner && (
                    <TabPane tab='Retail' key='store'>
                      <StoreMenuContent
                        page={page}
                        per_page={per_page}
                        user={user}
                        handlePageChange={handlePageChange}
                        onShowSizeChange={onShowSizeChange}
                        categories={categories?.filter(
                          x => x.featureType === 'store'
                        )}
                        updateCount={updateCount}
                      />
                    </TabPane>
                  )}
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterDisplay />

      <Modal open={isModalVisible} footer={null} width={'700px'}>
        <MenuTipsContent />
        <div className={'flex my-3 md:justify-end'}>
          <button
            onClick={handleTipCancel}
            className={'py-3 px-10 bg-green-800 text-white rounded-full'}
          >
            Got it
          </button>
        </div>
      </Modal>
    </div>
  )
}

export default RestaurantMenu
